<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/QahuIO/images/cover.jpg?1734367818956" alt="This image is the cover for the book Founding Leadership"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Founding Leadership
      </h1>
      <p class="bookDescription body article font2">
        <b>What would Washington (or Jefferson or Hamilton) do? Practical leadership lessons from the eighteenth century that you can use today.</b><br/>  <br/> To many, the leaders of the American Revolution are distant men of myth—stoic, heroic, and unknowable. People take for granted that these men were brilliant, but rarely ask why. What distinguished them from their fellow citizens, both then and now? What can they teach about leadership, and about realizing both career and personal goals?<br/>  <br/><i>Founding Leadership</i> reveals the human side of these “marble men,” examining the words, deeds, and personal qualities that allowed Washington, Jefferson, Adams, Hamilton, and others to achieve their utopian aims. Historian Brent Taylor demonstrates that effective leadership requires more than perseverance and a laundry list of how-to steps. It requires leaders to conceive visions greater than themselves, then communicate those visions in ways that inspire, persuade, and motivate others.<br/>  <br/> In examining historical episodes both famous and obscure, Taylor uncovers the light and dark sides of power, including the motivations behind Benedict Arnold’s infamous betrayal. Through these fascinating studies, you can become more attuned to America’s past and—most importantly—to your own leadership potential.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Brent Taylor
      </h2>
      
      <p class="authorDescription body article"><B>Brent Taylor</B> is a pastor, international speaker, professor of American history, and corporate communicator. He holds degrees from Baylor University as well as two seminaries and is a member of the distinguished Presidential Leadership Scholars program.  He teaches US History at Dallas Baptist University. He has published in the Huffington Post and for LifeWay Christian Resources. Brent lives in the Dallas area with his wife and three children.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Morgan James Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?182ec690